import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import styles from "../Users/users.module.css";

import GridTable from "../../../Components/CommonTable/GridTable/GridTable";
import Filters from "../../../Components/Common/Filters/Filters";
import { useFetchAll } from "../../../custom/FetchApiHook";
import { UsersApi } from "../../../App/api/users.api";
import filters from "./Filters";
import { DeliveryManApis } from "../../../App/api/delivery.apis";
import DeliveryManGridTable from "../../../Components/CommonTable/GridTable/DeliveryManGridTable";
 

const Drivers = ({meta}) => {
  const [toggleUsers, SetToggleUser] = useState("ONLINE");
  const [gridToggle, SetGridToggle] = useState(false);

  const debounceTimeout=useRef()
  const [search, setSearch] = useState("");  
  const [pagination,setPagination]=useState({
    page: 1,
    limit: 10,
    sortOrder: "desc",
    filter: ""
  })
 
  const {value, fetchAllData } = useFetchAll(() =>DeliveryManApis.getAllDeliveryMan(pagination));
  
  const handlePagination=(data)=>{
    // console.log(data);
    
    if (data.clearPagination) {
      setPagination(data.clearPagination)
      return
    }
    
    setPagination((prev)=>{
        let copyfilter={...prev.filter}
        // copyfilter[]
       
        if (data.filter) {
          // console.log("Object.keys[copyfilter]",Object.entries(copyfilter))
          // console.log("Object.keys[copyfilter]",Object.keys(data.filter))
          
          if (copyfilter[Object.keys(data.filter)[0]]) {
            copyfilter[Object.keys(data.filter)[0]]=Object.values(data.filter)[0]
            
          }else{

            copyfilter={...data?.filter,...copyfilter}
          }
        
        }
       
  
        return{
          page:data.page?data.page:prev.page,
          limit:data.limit?data.limit:prev.limit,
          sortOrder:data.sortOrder?data.sortOrder:prev.sortOrder,
          filter:copyfilter
        }
  
      })
    }

    
  const handleSearch = useCallback((s) => {
    // console.log('Search at OrderCom', s);
    setSearch(s);
}, []);

 filters.handleSearch = useCallback((s) => {
  if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
  } 
  debounceTimeout.current = setTimeout(() => {
      handleSearch(s); 
  }, 1500);
}, [handleSearch]);


filters.handleClearFilter=()=>{
const clearPagination=  {
    "page": 1,
    "limit": 5,
    "sortOrder": "desc",
    "filter": {}
  }
  // console.log('clearPagination',clearPagination);
  handlePagination && handlePagination({clearPagination})
}
filters.handleFilter=(name,value)=>{
console.table('name,value',name,value);
let data={}
if (name==='search_by') {
  data.sortOrder=value.code
}
else{
 
  const filter={}
  filter[name]=value.code?value.code:value
  data.filter=filter
  
}

// console.log('data',data);
 handlePagination && handlePagination(data)


}



useEffect(() => {
  // fetchAllData()
}, [pagination,search]);

  return (
    <>
      <CommonLayout />

      <div style={{ paddingBottom: "4rem" }}>
        {/* <Filters
          SetGridToggle={SetGridToggle}
          gridToggle={gridToggle}
          type={"drivers"}
        /> */}
        <div className={styles.users_toggle_container}>
          <span
            style={{
              color: toggleUsers === "ONLINE" ? "#e34e4e" : "var(--text-color3)",
            }}
            onClick={() => SetToggleUser("ONLINE")}
          >
            ONLINE
          </span>
          <span
            style={{
              color:
                toggleUsers === "APPROVED" ? "#e34e4e" : "var(--text-color3)",
            }}
            onClick={() => SetToggleUser("APPROVED")}
          >
            APPROVED
          </span>
          <span
            style={{
              color:
                toggleUsers === "UNAPPROVED" ? "#e34e4e" : "var(--text-color3)",
            }}
            onClick={() => SetToggleUser("UNAPPROVED")}
          >
            UNAPPROVED
          </span>
        </div>
        
        <div style={{ padding: "2rem" }}>
          <DeliveryManGridTable 
          FilterData={filters}
          handlePagination={handlePagination}
          isGrid={gridToggle} 
          SetGridToggle={SetGridToggle} 
          type={"drivers"} 
          value={value}
          />
        </div>
      </div>
    </>
  );
};

export default Drivers;
